//const dominio = "http://127.0.0.1:8000";
//const dominio = "http://sim.pruebas.cpe.gov.co";
const dominio = "http://sim.cpe.gov.co";
const version = "/rest/v1.0";
import store from "./store";

// Objeto con las rutas del api
const rutas = {
    
    // POST
    consultarCedula: `${dominio}${version}/consultar/:{estrategia}/`,
    preInscribir: `${dominio}${version}/eventos/:{estrategia}/`, 

    // GET
    departamentos: `${dominio}${version}/departamentos/`,
    municipiosDepartamento: `${dominio}${version}/departamentos/:{departamentoId}/`,
    municipios: `${dominio}${version}/municipios/`,
    detalleMunicipio: `${dominio}${version}/municipios/:{municipioId}`, 
    detallePreinscripcion: `${dominio}${version}/eventodetalle/`, 
   // sedesMunicipio: `${dominio}${version}/radicados/:{municipioId}`,
    sedesMunicipio: `${dominio}${version}/radicados/:{municipioId}/:{tipoIns}/`,
    generos: `${dominio}${version}/generos/`,
    tiposDocumento: `${dominio}${version}/tipos_documento/`,
    tiposVinculacion:`${dominio}${version}/generos/`,
    areasConocimiento:`${dominio}${version}/area/`,
    nivlesEducacion:`${dominio}${version}/nivel/`,
    tiposParticipante:`${dominio}${version}/participante/`,
    nombresEquipos:`${dominio}${version}/equipo/`,
    consultarAgenda: `${dominio}${version}/agenda/:{inscripcion}/`,
    horarios: `${dominio}${version}/agenda/:{inscripcion}/`, 
    tipoInstituciones: `${dominio}${version}/sector/`, 
   
};


// Exportar rutas individualmente como un string
export const detallePreinscripcion = rutas.detallePreinscripcion;
export const consultarCedula = () =>
    rutas.consultarCedula.replace(":{estrategia}", store.state.slugId);
export const preInscribir = () =>
    rutas.preInscribir.replace(":{estrategia}", store.state.slugId);
export const departamentos = rutas.departamentos;
export const municipios = rutas.municipios;
export const generos = rutas.generos;
export const tiposDocumento = rutas.tiposDocumento;
export const tiposVin = rutas.tiposVinculacion;
export const areas = rutas.areasConocimiento;
export const niveles = rutas.nivlesEducacion;
export const tiposParti = rutas.tiposParticipante;
export const nombresEquipos = rutas.nombresEquipos;
export const tipoInstituciones = rutas.tipoInstituciones;
export const consultarAgenda = () =>
    rutas.consultarAgenda.replace(":{inscripcion}", store.state.slugId);
export const municipiosDepartamento = (departamentoId) =>
    rutas.municipiosDepartamento.replace(":{departamentoId}", departamentoId);
export const detalleMunicipio = (municipioId) =>
    rutas.detalleMunicipio.replace(":{municipioId}", municipioId);
//export const sedesMunicipio = (municipioId) =>
//    rutas.sedesMunicipio.replace(":{municipioId}", municipioId);
export const sedesMunicipio = (municipioId,idTipo) =>
    rutas.sedesMunicipio.replace(":{municipioId}/:{tipoIns}", municipioId+"/"+idTipo);
export const horarios = (slugId) =>
    rutas.horarios.replace(":{inscripcion}", slugId);

export default rutas;
